import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "image-operation"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "image-mj-btns"
};
import { Delete, Download, View } from '@element-plus/icons-vue';
import { toRefs } from 'vue';
import { ElLoading } from 'element-plus';
import { AiImageStatusEnum } from '@/views/aip/utils/constants';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageCard',
  props: {
    detail: {
      type: Object,
      require: true
    }
  },
  emits: ['onBtnClick', 'onMjBtnClick'],
  setup(__props, {
    emit: __emit
  }) {
    const message = useMessage(); // 消息
    const props = __props;
    const cardImageRef = ref(); // 卡片 image ref
    const cardImageLoadingInstance = ref(); // 卡片 loading 实例
    const currentImageId = ref(null); // 当前图片ID，用于避免多实例冲突
    /** 处理点击事件  */
    const handleButtonClick = async (type, detail) => {
      emits('onBtnClick', type, detail);
    };
    /** 处理 Midjourney 按钮点击事件  */
    const handleMidjourneyBtnClick = async button => {
      // 确认窗体
      await message.confirm(`确认操作 "${button.label} ${button.emoji}" ?`);
      emits('onMjBtnClick', button, props.detail);
    };
    const emits = __emit; // emits
    /** 处理加载状态 */
    const handleLoading = async (status, imageId) => {
      // 如果传入了imageId，更新当前图片ID
      if (imageId !== undefined) {
        currentImageId.value = imageId;
      }
      // 情况一：如果是生成中，则设置加载中的 loading
      if (status === AiImageStatusEnum.IN_PROGRESS) {
        // 如果已经有loading实例且是同一个图片，不重复创建
        if (cardImageLoadingInstance.value && currentImageId.value === imageId) {
          return;
        }
        // 先关闭之前的loading实例
        if (cardImageLoadingInstance.value) {
          cardImageLoadingInstance.value.close();
          cardImageLoadingInstance.value = null;
        }
        // 创建新的loading实例
        cardImageLoadingInstance.value = ElLoading.service({
          target: cardImageRef.value,
          text: '生成中...'
        });
        // 情况二：如果已经生成结束，则移除 loading
      } else {
        // 只有当前图片ID匹配时才关闭loading
        if (cardImageLoadingInstance.value && (imageId === undefined || currentImageId.value === imageId)) {
          cardImageLoadingInstance.value.close();
          cardImageLoadingInstance.value = null;
          currentImageId.value = null;
        }
      }
    };
    /** 监听详情 */
    const {
      detail
    } = toRefs(props);
    watch(() => detail?.value, async (newVal, oldVal) => {
      if (!newVal) {
        return;
      }
      // 只有当状态真正发生变化时才处理loading
      const newStatus = newVal?.status;
      const oldStatus = oldVal?.status;
      const imageId = newVal?.id;
      // 如果状态没有变化且不是首次加载，则不处理
      if (oldVal && newStatus === oldStatus && currentImageId.value === imageId) {
        return;
      }
      await handleLoading(newStatus, imageId);
    }, {
      deep: true,
      // 深度监听
      immediate: false // 不立即执行，避免与onMounted冲突
    });
    /** 初始化 */
    onMounted(async () => {
      if (!props.detail) {
        return;
      }
      await handleLoading(props.detail?.status, props.detail?.id);
    });
    /** 组件卸载时清理loading实例 */
    onUnmounted(() => {
      if (cardImageLoadingInstance.value) {
        cardImageLoadingInstance.value.close();
        cardImageLoadingInstance.value = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        "body-class": "",
        class: "image-card"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_unref(detail)?.status === _unref(AiImageStatusEnum).IN_PROGRESS ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          text: "",
          bg: ""
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 生成中 ")])),
          _: 1
        })) : _unref(detail)?.status === _unref(AiImageStatusEnum).SUCCESS ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          text: "",
          bg: ""
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 已完成 ")])),
          _: 1
        })) : _unref(detail)?.status === _unref(AiImageStatusEnum).FAIL ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "danger",
          text: "",
          bg: ""
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 异常 ")])),
          _: 1
        })) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Download),
          onClick: _cache[0] || (_cache[0] = $event => handleButtonClick('download', _unref(detail)))
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(Delete),
          onClick: _cache[1] || (_cache[1] = $event => handleButtonClick('delete', _unref(detail)))
        }, null, 8, ["icon"]), _createVNode(_component_el_button, {
          class: "btn",
          text: "",
          icon: _unref(View),
          onClick: _cache[2] || (_cache[2] = $event => handleButtonClick('more', _unref(detail)))
        }, null, 8, ["icon"])])]), _createElementVNode("div", {
          class: "image-wrapper",
          ref_key: "cardImageRef",
          ref: cardImageRef
        }, [_createVNode(_component_el_image, {
          class: "image",
          src: _unref(detail)?.picUrl,
          "preview-src-list": _unref(detail)?.picUrl ? [_unref(detail).picUrl] : [],
          "preview-teleported": ""
        }, null, 8, ["src", "preview-src-list"]), _unref(detail)?.status === _unref(AiImageStatusEnum).FAIL ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(detail)?.errorMessage), 1)) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail)?.buttons, (button, index) => {
          return _openBlock(), _createBlock(_component_el_button, {
            size: "small",
            key: index,
            class: "min-w-40px ml-0 mr-10px mt-5px",
            onClick: $event => handleMidjourneyBtnClick(button)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(button.label) + _toDisplayString(button.emoji), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});